import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { LoginComponent } from "./components/login/login.component";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { ContentComponent } from "./components/content/content.component";
import { OrderComponent } from "./components/order/order.component";
import { ManageComponent } from "./components/manage/manage.component";
import { ManageuserComponent } from "./components/manage/manage-user.component";
import { MaintenanceComponent } from "./components/maintenance/maintenance.component";
import { ReturnComponent } from "./components/return/return.component";
import { ReportpartnerComponent } from "./components/reportpartner/reportpartner.component";
import { ViewuserComponent } from "./components/viewuser/viewuser.component";
import { ViewserviceComponent } from "./components/viewservice/viewservice.component";
import { CustomerComponent } from "./components/customer/customer.component";
import { CustomerviewComponent } from "./components/customer/customer-view.component";
import { CustomerserviceComponent } from "./components/customer/customer-service.component";
import { SetcustomerComponent } from "./components/setcustomer/setcustomer.component";
import { StokstbComponent } from "./components/stokstb/stokstb.component";
import { HomeComponent } from "./components/home/home.component";
import { AuthGuard } from "./_helpers/auth.guard";
import { PartnerComponent } from "./components/partner/partner.component";
import { PartnerservicequotaComponent } from "./components/partner/partner-servicequota.component";

import { SingleviewComponent } from "./components/singleview/singleview.component";
import { ProductsComponent } from "./components/products/products.component";
import { ProductvoucherComponent } from "./components/products/productvoucher.component";
import { ProductvoucherbatchdetailComponent } from "./components/products/productvoucherbatchdetail.component";
import { ProductvoucherlistComponent } from "./components/products/productvoucherlist.component";
import { ProductvoucherbatchlistComponent } from "./components/products/productvoucherbatchlist.component";
import { ProductvoucherordermanualComponent } from "./components/products/productvoucherordermanual.component";

import { OrderserviceComponent } from "./components/orderservice/orderservice.component";
import { EditpartnerComponent } from "./components/editpartner/editpartner.component";
import { OrderservicecreateComponent } from "./components/orderservice/orderservicecreate.component";

import { AdminpartnerComponent } from "./components/adminpartner/adminpartner.component";
import { AdminpartnerServComponent } from "./components/adminpartner/adminpartner-serv.component";
import { AdminpartnerQuotaComponent } from "./components/adminpartner/adminpartner-quota.component";
import { AdminpartnerCustComponent } from "./components/adminpartner/adminpartner-cust.component";
import { AdminpartnerListstbComponent } from "./components/adminpartner/adminpartner-liststb.component";
import { AdminpartnerRekapdataComponent } from "./components/adminpartner/adminpartner-rekapdata.component";

import { AdminsalesComponent } from "./components/adminsales/adminsales.component";
import { AdminsalesStbComponent } from "./components/adminsales/adminsales-stb.component";
import { AdminsalesServComponent } from "./components/adminsales/adminsales-serv.component";
import { AdminsalesOrderstbComponent } from "./components/adminsales/adminsales-orderstb.component";
import { AdminsalesOrderservComponent } from "./components/adminsales/adminsales-orderserv.component";
import { AdminsalesListorderComponent } from "./components/adminsales/adminsales-listorder.component";
import { AdminsalesViewComponent } from "./components/adminsales/adminsales-view.component";
import { PartnerFormComponent } from "./components/partner/partner-form.component";
import { AdminwicComponent } from "./components/adminwic/adminwic.component";
import { AdminwicCustComponent } from "./components/adminwic/adminwic-cust.component";
import { AdminwicListstbComponent } from "./components/adminwic/adminwic-liststb.component";
import { AdminwicWicstbComponent } from "./components/adminwic/adminwic-wicstb.component";
import { ListstbComponent } from "./components/liststb/liststb.component";
import { PartnerListstbComponent } from "./components/partner/partner-liststb.component";
import { MaintenancePartnerComponent } from "./components/maintenance/maintenance-partner.component";
import { AdminpartnerPendingComponent } from "./components/adminpartner/adminpartner-pending.component";
import { AdminactivationComponent } from "./components/adminactivation/adminactivation.component";
import { AdminactivationViewComponent } from "./components/adminactivation/adminactivation-view.component";
import { AddservicebulkyComponent } from "./components/manage/addservicebulky.component";

import { OrderListComponent } from "./components/order/order-list.component";
// import { OrderViewComponent } from "./components/order/order-view.component";
import { ManageProvComponent } from "./components/manage/manage-prov.component";
import { AdmincallcenterComponent } from "./components/admincallcenter/admincallcenter.component";
import { AdminCCManageComponent } from "./components/admincallcenter/manage-service.component";
import { AdminCCCustomerComponent } from "./components/admincallcenter/customer-cc.component";
import { AdminCCActivationComponent } from "./components/admincallcenter/activation-cc.component";
import { AdminsuperbranchComponent } from "./components/adminsuperbranch/adminsuperbranch.component";
import { AdminsbManageComponent } from "./components/adminsuperbranch/adminsb-manage.component";
import { AdminsbCustomerComponent } from "./components/adminsuperbranch/adminsb-customer.component";
import { AdminsbMaintenanceComponent } from "./components/adminsuperbranch/adminsb-maintenance.component";
import { AdminsbListstbComponent } from "./components/adminsuperbranch/adminsb-liststb.component";
import { AdminsbSbstbComponent } from "./components/adminsuperbranch/adminsb-sbstb.component";
import { AdminsalesChangeComponent } from "./components/adminsales/adminsales-change.component";
import { AdminsalesServicequotaComponent } from "./components/adminsales/adminsales-servicequota.component";
import { AdminsalesChangeserviceComponent } from "./components/adminsales/adminsales-changeservice.component";
import { AdminlogisticComponent } from "./components/adminlogistic/adminlogistic.component";
import { AdminlogListstbComponent } from "./components/adminlogistic/adminlog-liststb.component";
import { AdminlogViewComponent } from "./components/adminlogistic/adminlog-view.component";
import { AdminsalesListorderstbonlyComponent } from "./components/adminsales/adminsales-listorderstbonly.component";
import { AdminsalesOrderstbonlyComponent } from "./components/adminsales/adminsales-orderstbonly.component";
//import { AdminwicCustreportComponent } from './components/adminwic/adminwic-custreport.component';
import { AdminrevaComponent } from "./components/adminreva/adminreva.component";
import { AdminrevaCustreportComponent } from "./components/adminreva/adminreva-custreport.component";
import { AdminrevaSummarycicilanComponent } from "./components/adminreva/adminreva-summarycicilan.component";
import { AdminrevaSummarycicilanagingComponent } from "./components/adminreva/adminreva-summarycicilanaging.component";

import { ReleasestbComponent } from "./components/releasestb/releasestb.component";
import { RequestreleaseComponent } from "./components/releasestb/requestrelease.component";
import { ReleasestbViewComponent } from "./components/releasestb/releasestb-view.component";

import { ListorderComponent } from "./components/adminecommerceold/listorder.component";
import { OrderviewComponent } from "./components/adminecommerceold/order-view.component";
// ecommerce  marketplace form
import { MarketplaceformComponent } from "./components/adminecommerceold/marketplace-form.component";

import { PurchaseComponent } from "./components/purchase/purchase.component";
import { OperationComponent } from "./components/operation/operation.component";
import { TestareaComponent } from "./components/operation/testarea.component";

import { NotificationComponent } from "./components/operation/notification/notification.component";
import { CancelComponent } from "./components/operation/cancelcustomer/cancel.component";
import { UpdatepaytvComponent } from "./components/operation/updatepaytv/updatepaytv.component";

import { AdminpartnerNotifComponent } from "./components/adminpartner/adminpartner-notif.component";
import { PlayboxComponent } from "./components/playbox/playbox.component";
import { InformationComponent } from "./components/playbox/information.component";
import { MessageComponent } from "./components/playbox/message.component";
import { PromoComponent } from "./components/promo/promo.component";
import { RunningtextComponent } from "./components/playbox/runningtext.component";

import { AdminapComponent } from "./components/adminap/adminap.component";
import { AdminapviewComponent } from "./components/adminap/adminap-view.component";
import { AdminapverifiedComponent } from "./components/adminap/adminap-verified.component";

import { AdminapecommerceComponent } from "./components/adminap/adminap-ecommerce.component";
import { AdminapverifiedecommerceComponent } from "./components/adminap/adminap-verifiedecommerce.component";

import { AdminapviewecommerceComponent } from "./components/adminap/adminap-viewecommerce.component";

/* dismantle */
import { AdmindismantleComponent } from "./components/admindismantle/admindismantle.component";
//import { AdmindismantleviewComponent } from './components/admindismantle/admindismantle-view.component';
//import { AdmindismantleverifiedComponent } from './components/admindismantle/admindismantle-verified.component';

import { AdminvoucherListtransaksiComponent } from "./components/adminvoucher/adminvoucher-listtransaksi.component";
import { AdminvoucherlistComponent } from "./components/adminvoucher/adminvoucherlist.component";
import { AdminvoucherProductsComponent } from "./components/adminvoucher/adminvoucher-products.component";
import { ManageProvFormComponent } from "./components/manage/manage-prov-form.component";
import { ListStoreshopComponent } from "./components/adminecommerceold/storeshop/list-storeshop.component";
import { FormStoreshopComponent } from "./components/adminecommerceold/storeshop/form-storeshop.component";
import { AdminrevaDetailCicilanComponent } from "./components/adminreva/adminreva-detail-cicilan.component";
import { AdminrevaDetailOutstandingComponent } from "./components/adminreva/adminreva-detail-outstanding.component";
import { AdminrevaDaftarPelangganCicilanComponent } from "./components/adminreva/adminreva-daftar-pelanggan-cicilan.component";

import { AppsListComponent } from "./components/cgmn/apps-list.component";
import { MasterPackageComponent } from "./components/cgmn/master-package.component";
import { MasterThemeComponent } from "./components/cgmn/master-theme.component";
import { AdminNextsysListOrderStbComponent } from "./components/adminnextsys/adminnextsys-listorderstb.component";
import { AdminNextsysListOrderStbDetailComponent } from "./components/adminnextsys/adminnextsys-listorderstb-detail.component";
import { AdminNextsysOrderStbComponent } from "./components/adminnextsys/adminnextsys-orderstb.component";
import { PartnerNextsysComponent } from "./components/partnernextsys/partnernextsys.component";
import { ListstbnextsysComponent } from "./components/liststbnextsys/liststbnextsys.component";
import { ManageusernextsysComponent } from "./components/manage/manage-user-nextsys.component";
import { PartnerNextsysListStbComponent } from "./components/partnernextsys/partnernextsys-liststb.component";
import { PartnerNextsysFormComponent } from "./components/partnernextsys/partnernextsys-form.component";
import { AdminNextsysChangeLauncherComponent } from "./components/adminnextsys/adminnextsys-change-launcher.component";
import { AdminNextsysManageServiceComponent } from "./components/adminnextsys/adminnextsys-manage-service.component";
import { AdminNextsysManageServiceSTBComponent } from "./components/adminnextsys/adminnextsys-manage-service-stb.component";
import { ListpackagenextsysComponent } from "./components/listpackagenextsys/listpackagenextsys.component";
import { FormOrderComponent } from "./components/adminecommerce/formorder.component";
import { ListOrderComponent } from "./components/adminecommerce/listorder.component";
import { OrderViewComponent } from "./components/adminecommerce/order-view.component";
import {IsporderComponent} from '@app/components/isporder/isporder.component';
import { LauncherVersionComponent } from "./components/cgmn/launcher-version.component";
import { AdminNextsysManageServiceSTBDetailComponent } from "./components/adminnextsys/adminnextsys-manage-service-stb-detail.component";
import { MasterChannelComponent } from "./components/cgmn/master-channel.component";
import { ChannelListComponent } from "./components/cgmn/channel-list.component";
import { CgmnNotificationComponent } from "./components/adminnextsys/notification.component";
import { MessageTemplateComponent } from "./components/cgmn/message-template.component";

const routes: Routes = [
  { path: "", redirectTo: "/home", pathMatch: "full" },
  { path: "login", component: LoginComponent },
  { path: "singleview/:id", component: SingleviewComponent },
  { path: "purchase", component: PurchaseComponent },
  { path: "purchase/:id", component: PurchaseComponent },
  { path: "order/:isp", component: IsporderComponent, data: { title: 'About Us' } },
  {
    path: "",
    component: DashboardComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "home",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "", component: HomeComponent, canActivate: [AuthGuard] },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },
      {
        path: "order",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "", component: OrderComponent },
          { path: "listorder", component: OrderListComponent },
          { path: "view/:id", component: OrderViewComponent },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },
      {
        path: "orderservice",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "", component: OrderserviceComponent },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },
      {
        path: "orderservicecreate",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "", component: OrderservicecreateComponent },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },
      {
        path: "manage",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "", component: ManageComponent },
          { path: "manageuser", component: ManageuserComponent },
          {
            path: "manage-user-nextsys",
            component: ManageusernextsysComponent,
          },
          { path: "provisioning", component: ManageProvComponent },
          { path: "provisioning-form", component: ManageProvFormComponent },
          { path: "provisioning-form/:id", component: ManageProvFormComponent },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },
      {
        path: "maintenance",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "", component: MaintenanceComponent },
          { path: "partner", component: MaintenancePartnerComponent },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },
      {
        path: "customers",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "", component: CustomerComponent },
          { path: "view/:id", component: CustomerviewComponent },
          { path: "services/:id", component: CustomerserviceComponent },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },
      {
        path: "liststb",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "", component: ListstbComponent },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },
      {
        path: "return",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "", component: ReturnComponent },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },
      {
        path: "reportpartner",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          // {path: '', component: ReportpartnerComponent},
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },
      {
        path: "viewuser/:id",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "", component: ViewuserComponent },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },
      {
        path: "setcustomer/:id",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "", component: SetcustomerComponent },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },
      {
        path: "services/:id",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "", component: ViewserviceComponent },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },
      {
        path: "partner",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "", component: PartnerComponent },
          { path: "servicequota/:id", component: PartnerservicequotaComponent },
          { path: "createpartner", component: PartnerFormComponent },
          { path: "stb/:id", component: PartnerListstbComponent },
          // {path: 'editpartner/:id', component:  EditpartnerComponent},
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },
      {
        path: "stokstb",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "", component: StokstbComponent },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },
      {
        path: "products",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "", component: ProductsComponent },
          { path: "voucher/:id", component: ProductvoucherComponent },
          {
            path: "voucher/:id/:batchid",
            component: ProductvoucherbatchdetailComponent,
          },
          {
            path: "ordervoucher/:id/:trxid",
            component: ProductvoucherordermanualComponent,
          },
          {
            path: "batchlistvoucher/:id",
            component: ProductvoucherbatchlistComponent,
          },
          { path: "listvoucher/:id", component: ProductvoucherlistComponent },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },
      {
        path: "adminpartner",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "", component: AdminpartnerComponent },
          {
            path: "partnermanageservice",
            component: AdminpartnerServComponent,
          },
          { path: "partnercustomer", component: AdminpartnerCustComponent },
          {
            path: "partnerservicequota",
            component: AdminpartnerQuotaComponent,
          },
          { path: "partnerliststb", component: AdminpartnerListstbComponent },
          {
            path: "partnerstbpending",
            component: AdminpartnerPendingComponent,
          },
          {
            path: "servicenotification",
            component: AdminpartnerNotifComponent,
          },
          { path: "rekapdata", component: AdminpartnerRekapdataComponent },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },
      {
        path: "adminsales",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "", component: AdminsalesComponent },
          // {path: 'stb', component: AdminsalesStbComponent},
          { path: "listorder", component: AdminsalesListorderComponent },
          {
            path: "listorderstbonly",
            component: AdminsalesListorderstbonlyComponent,
          },
          { path: "listorderservice", component: AdminsalesServComponent },
          { path: "orderstb", component: AdminsalesOrderstbComponent },
          { path: "orderstbonly", component: AdminsalesOrderstbonlyComponent },
          { path: "orderservice", component: AdminsalesOrderservComponent },
          { path: "view/:id", component: AdminsalesViewComponent },
          { path: "change", component: AdminsalesChangeComponent },
          {
            path: "servicequota/:id",
            component: AdminsalesServicequotaComponent,
          },
          {
            path: "changeservice/:id",
            component: AdminsalesChangeserviceComponent,
          },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },
      {
        path: "adminwic",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "", component: AdminwicComponent },
          { path: "customer", component: AdminwicCustComponent },
          //{path: 'custreport', component: AdminwicCustreportComponent},
          { path: "liststb", component: AdminwicListstbComponent },
          { path: "wicstb", component: AdminwicWicstbComponent },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },
      {
        path: "adminactivation",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "", component: AdminactivationComponent },
          { path: "view/:id", component: AdminactivationViewComponent },
          { path: "addservicebulky", component: AddservicebulkyComponent },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },
      {
        path: "admincallcenter",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "", component: AdmincallcenterComponent },
          { path: "manage-service", component: AdminCCManageComponent },
          { path: "customer", component: AdminCCCustomerComponent },
          { path: "activation", component: AdminCCActivationComponent },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },
      {
        path: "adminsuperbranch",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "", component: AdminsuperbranchComponent },
          { path: "manage-service", component: AdminsbManageComponent },
          { path: "customer", component: AdminsbCustomerComponent },
          { path: "maintenance", component: AdminsbMaintenanceComponent },
          { path: "all-stb", component: AdminsbListstbComponent },
          { path: "sb-stb", component: AdminsbSbstbComponent },
          { path: "activation", component: AdminCCActivationComponent },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },
      {
        path: "adminlogistic",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "", component: AdminlogisticComponent },
          { path: "listorder", component: AdminlogListstbComponent },
          { path: "view/:id", component: AdminlogViewComponent },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },
      {
        path: "adminreva",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "", component: AdminrevaComponent },
          { path: "custreport", component: AdminrevaCustreportComponent },
          {
            path: "summarycicilan",
            component: AdminrevaSummarycicilanComponent,
          },
          {
            path: "summarydetailcicilan",
            component: AdminrevaDetailCicilanComponent,
          },
          {
            path: "summarycicilanaging",
            component: AdminrevaSummarycicilanagingComponent,
          },
          {
            path: "summarydetailoutstanding",
            component: AdminrevaDetailOutstandingComponent,
          },
          {
            path: "summarylistcustomer",
            component: AdminrevaDaftarPelangganCicilanComponent,
          },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },
      {
        path: "releasestb",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "", component: ReleasestbComponent },
          { path: "request", component: RequestreleaseComponent },
          { path: "view/:id", component: ReleasestbViewComponent },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },

      // old ecommerce routes
      // {
      //   path: "adminecommerce",
      //   component: ContentComponent,
      //   canActivate: [AuthGuard],
      //   children: [
      //     { path: "marketplaceform", component: MarketplaceformComponent },
      //     { path: "listorder", component: ListorderComponent },
      //     { path: "view/:id", component: OrderviewComponent },
      //     { path: "storeshop", component: ListStoreshopComponent },
      //     { path: "storeshop-form", component: FormStoreshopComponent },
      //     { path: "storeshop-form/:id", component: FormStoreshopComponent },
      //     { path: "**", redirectTo: "", pathMatch: "full" },
      //   ],
      // },

      {
        path: "adminecommerce",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "formorder", component: FormOrderComponent },
          { path: "listorder", component: ListOrderComponent },
          { path: "view/:id", component: OrderViewComponent },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ]
      },

      {
        path: "adminap",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "approvalcustomer", component: AdminapComponent },
          {
            path: "approvalcustomerecommerce",
            component: AdminapecommerceComponent,
          },
          { path: "verifiedcustomer", component: AdminapverifiedComponent },
          {
            path: "verifiedcustomerecommerce",
            component: AdminapverifiedecommerceComponent,
          },
          { path: "view/:id", component: AdminapviewComponent },
          {
            path: "viewecommerce/:id",
            component: AdminapviewecommerceComponent,
          },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },

      {
        path: "admindismantle",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "kandidat", component: AdmindismantleComponent },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },

      {
        path: "operation",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "testarea", component: TestareaComponent },
          { path: "servicenotification", component: NotificationComponent },
          { path: "cancelcustomer", component: CancelComponent },
          { path: "updatepaytv", component: UpdatepaytvComponent },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },
      {
        path: "playbox",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "parental", component: PlayboxComponent },
          { path: "information", component: InformationComponent },
          { path: "message", component: MessageComponent },
          { path: "runningtext", component: RunningtextComponent },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },
      {
        path: "promo",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "", component: PromoComponent },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },

      {
        path: "adminvoucher",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "", component: AdminvoucherListtransaksiComponent },
          // {path: 'customer', component: AdminwicCustComponent},
          //{path: 'custreport', component: AdminwicCustreportComponent},
          { path: "transaksi", component: AdminvoucherListtransaksiComponent },
          { path: "list/:id", component: AdminvoucherlistComponent },
          { path: "product", component: AdminvoucherProductsComponent },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },
      {
        path: "cgmn",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "launcher-version", component: LauncherVersionComponent },
          { path: "apps", component: AppsListComponent },
          { path: "channels", component: ChannelListComponent },
          { path: "master-theme", component: MasterThemeComponent },
          { path: "master-package", component: MasterPackageComponent },
          { path: "master-channel", component: MasterChannelComponent },
          { path: "message-template", component: MessageTemplateComponent },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },
      {
        path: "adminnextsys",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "", component: AdminsalesComponent },
          { path: "listorder", component: AdminNextsysListOrderStbComponent },
          {
            path: "change-launcher",
            component: AdminNextsysChangeLauncherComponent,
          },
          {
            path: "manage-service",
            component: AdminNextsysManageServiceComponent,
          },
          {
            path: "manage-service/:id/stb",
            component: AdminNextsysManageServiceSTBComponent,
          },
          {
            path: "manage-service/:id/stb/:idstb",
            component: AdminNextsysManageServiceSTBDetailComponent,
          },
          {
            path: "order/detail/:id",
            component: AdminNextsysListOrderStbDetailComponent,
          },
          { path: "notifications", component: CgmnNotificationComponent },
          { path: "orderstb", component: AdminNextsysOrderStbComponent },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },
      {
        path: "partnernextsys",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "", component: PartnerNextsysComponent },
          // { path: "servicequota/:id", component: PartnerservicequotaComponent },
          { path: "createpartner", component: PartnerNextsysFormComponent },
          { path: "stb/:id", component: PartnerNextsysListStbComponent },
          // {path: 'editpartner/:id', component:  EditpartnerComponent},
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },
      {
        path: "liststbnextsys",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "", component: ListstbnextsysComponent },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },
      {
        path: "listpackagenextsys",
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: "", component: ListpackagenextsysComponent },
          { path: "**", redirectTo: "", pathMatch: "full" },
        ],
      },
    ],
  },

  { path: "**", redirectTo: "home", pathMatch: "full" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
